import CardBrand from './CardBrand';

export default CardBrand;
